import React from 'react';
import * as PropTypes from 'prop-types';
import { Card } from 'react-bootstrap';
import EditableTextArea from '../Common/EditableTextarea';
import { Button } from 'react-bootstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExternalLink } from '@whitebox-learning/fontawesome-pro-regular-svg-icons';

const RevisionDetails = ({ revision, openRevision, saveNotes }) => (
  <>
    <h4 className="mx-3">
      Revision {revision.revision}
      <Button
        size="sm"
        className="ms-3"
        onClick={() => openRevision(revision.id, revision.name)}
      >
        Open in Engineering
        <FontAwesomeIcon icon={faExternalLink} className="ms-2" />
      </Button>
    </h4>

    <div className="d-flex flex-grow-1 m-3 mt-1" style={{ minHeight: 0 }}>
      <Card className="panel-scroll">
        <Card.Header>
          <Card.Title>Changelog</Card.Title>
        </Card.Header>
        <Card.Body className="p-2 overflow-auto">
          <p className="journal-logs-changelog">{revision.changelog}</p>
        </Card.Body>
      </Card>

      <EditableTextArea
        className="panel-scroll mx-2"
        title="Notes"
        save={saveNotes}
        identifier={revision.id}
        content={revision.notes}
      />

      <Card className="panel-scroll">
        <Card.Header>
          <Card.Title>Analysis</Card.Title>
        </Card.Header>
        <Card.Body className="p-0">
          <table className="table table-condensed table-striped">
            <tbody>
              {revision.diagnostics?.map((row) => (
                <tr key={row.label}>
                  <td>{row.label}</td>
                  <td>{row.value}</td>
                  <td>{row.units}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </Card.Body>
      </Card>
    </div>
  </>
);

RevisionDetails.propTypes = {
  revision: PropTypes.object.isRequired,
};

export default RevisionDetails;
